'use strict';

const Guided = require('./guided');

function Help () {
	$(this.setup.bind(this));
};

Help.prototype.setup = function () {

	// Hide section if no guided tutorial
	if (!$('.tutorial-step').length) {
		$('.tutorial-intro-guided').hide();
	}

	// Hide section if no tips
	if (!$('.tutorial-tip-highlight').length) {
		$('.tutorial-intro-tips').hide();
	}

	this.toggle = require('./toggle.js');
	this.tips = require('./tips');
};

Object.defineProperty(Help.prototype, 'guided', {
	get: function () {
		if (!this._guided) {
			this._guided = new Guided();
			
			$('.tutorial-guided-start').on('click', () => {
				this.toggle.hide();
				this._guided.start()
			});
		}

		return this._guided;
	},
});

module.exports = Help;
